// extracted by mini-css-extract-plugin
export var label = "_ck-5";
export var slideContainer = "_ck-0";
export var slider = "_ck-1";
export var sliderLg = "_ck-4";
export var sliderMd = "_ck-3";
export var sliderSm = "_ck-2";